import Vue from 'vue';
import Router from 'vue-router';
import Authorization from '@/views/Authorization/Index.vue';
import EmailLogin from '@/views/Authorization/EmailLogin';
import DashboardIndex from '@/views/Dashboard/Index';
import ObjectsView from '@/views/Dashboard/Objects/Index';
import ProjectEdit from '@/views/Dashboard/Projects/Edit';
import AuthHandler from '@/views/Authorization/AuthHandler';
import ResetPassword from '@/views/Authorization/ResetPassword';
import JobsList from '@/views/Dashboard/Jobs/List';
import JobsCreate from '@/views/Dashboard/Jobs/Create';
import MaterialsCreate from '@/views/Dashboard/Jobs/Materials';

import ProjectsList from '@/views/Dashboard/Projects/List';
import ProfileEdit from '@/views/Dashboard/Profile/Edit';
import InfoView from '@/views/Dashboard/Info/Index';
import UsersView from '@/views/Dashboard/Users/List';
import UsersCreate from '@/views/Dashboard/Users/Create';
import UsersEdit from '@/views/Dashboard/Users/Edit';
import ReportsView from '@/views/Dashboard/Reports/Index';
import ReportsViewType from '@/views/Dashboard/Reports/Type';
import ReportsCreate from '@/views/Dashboard/Reports/Create';
import ClientList from '@/views/Admin/Clients/List';
import SelectUsers from '../views/Dashboard/Users/SelectUsers';
import WorkTypeView from '../views/Dashboard/WorkType/Index';
import WorkTypeCreate from '../views/Dashboard/WorkType/Create';
import WorkTypeEdit from '../views/Dashboard/WorkType/Create';
import WorkSection from '../views/Dashboard/Projects/WorkSection';
import AnalyticsView from '@/views/Dashboard/Analytics/List';
import AnalyticsViewType from '@/views/Dashboard/Analytics/Type';
import ConstructionEngineering from '@/views/Dashboard/Analytics/ConstructionEngineering';
import Performance from '@/views/Dashboard/Analytics/Performance';
import Welding from '@/views/Dashboard/Analytics/Welding';
import AnalyticsIndex from '@/views/Dashboard/Analytics/Index';
import ClientInfo from '../views/Admin/Clients/ClientInfo';
import AnalyticsJob from '@/views/Dashboard/Analytics/Job'
import AnalyticsJobPrice from '@/views/Dashboard/Analytics/JobPrice'
import DocumentationEdit from '@/views/Dashboard/Documentation/Edit'
import FilesView from '@/views/Dashboard/Files/List';
import FilesCreate from '@/views/Dashboard/Files/Create';
import DocsView from '@/views/Dashboard/Files/Index';

import UnitList from '../views/Dashboard/Unit/Index';
import UnitCreate from '../views/Dashboard/Unit/Create';
import JoinList from '../views/Dashboard/Join/Index';
import JoinCreate from '../views/Dashboard/Join/Create';

import TasksList from '../views/Dashboard/Tasks/List';
import TasksCreate from '../views/Dashboard/Tasks/Create';
import TasksCategoriesList from '../views/Dashboard/Tasks/Categories/List';
import TasksCategoriesCreate from '../views/Dashboard/Tasks/Categories/Create';


Vue.use(Router);

export default [
  {
    path: '/',
    name: 'Authorization-index',
    component: Authorization,
    meta: {
      guest: true,
    },
  },
  {
    path: '/auth',
    name: 'Authorization-handler',
    component: AuthHandler,
  },
  {
    path: '/sign/resetPassword/:code',
    name: 'Authorization-reset-password',
    component: ResetPassword,
    meta: {
      guest: true,
    },
  },
  {
    path: '/registration',
    name: 'Authorization-email-login',
    component: EmailLogin,
    meta: {
      guest: true,
    },
  },
  {
    path: '/dashboard',
    name: 'dashboard.index',
    component: DashboardIndex,
    meta: {
      auth: true,
    },
    children: [
      {
        path: '/',
        name: 'infoView',
        component: InfoView,
      },
      {
        path: 'tasks',
        name: 'tasks',
        component: TasksList,
      },
      {
        path: 'tasks/create/:id?',
        name: 'tasks-create',
        component: TasksCreate,
      },
      {
        path: 'tasks/categories',
        name: 'tasks-categories',
        component: TasksCategoriesList,
      },
      {
        path: 'tasks/create/:id/copy',
        name: 'tasksCopy',
        component: TasksCreate,
      },
      {
        path: 'tasks/categories/create/:id?',
        name: 'tasks-categories-create',
        component: TasksCategoriesCreate,
      },
      {
        path: 'documentation/edit',
        name: 'DocumentationEdit',
        component: DocumentationEdit,
      },
      {
        path: 'files/:id?',
        name: 'Files',
        component: FilesView,
      },
      {
        path: 'files/:id/edit/:type?',
        name: 'FilesEdit',
        component: FilesCreate,
        meta: {
          isBack: true,
        },
      },
      {
        path: 'docs',
        name: 'Docs',
        component: DocsView,
      },
      {
        path: 'files/:id/create/:type?',
        name: 'FileCreate',
        component: FilesCreate,
        meta: {
          isBack: true,
        },
      },
      {
        path: 'unit',
        name: 'unit',
        component: UnitList,
      },
      {
        path: 'unit/:id/edit',
        name: 'unit-edit',
        component: UnitCreate,
      },
      {
        path: 'unit/create',
        name: 'unit-create',
        component: UnitCreate,
      },

      {
        path: 'inch',
        name: 'inch',
        component: JoinList,
      },
      {
        path: 'inch/:id/edit',
        name: 'inch-edit',
        component: JoinCreate,
      },
      {
        path: 'inch/create',
        name: 'inch-create',
        component: JoinCreate,
      },
      {
        path: 'clients',
        name: 'admin',
        component: ClientList,
        meta: {
          auth: true,
          title: 'Список клиентов',
        },
      },
      {
        path: 'clients/:id',
        name: 'admin.client',
        component: ClientInfo,
        meta: {
          auth: true,
          title: 'Информация о клиенте по его созданым проектам',
        },
      },
      {
        path: 'objects',
        name: 'objects',
        component: ObjectsView,
      },
      {
        path: 'users',
        name: 'users',
        component: UsersView,
      },
      {
        path: 'analytics',
        name: 'analytics',
        component: AnalyticsIndex,
      },
      {
        path: 'reports',
        name: 'reports',
        component: ReportsView,
      },
      {
        path: 'work_section',
        name: 'work-section',
        component: WorkSection,
        meta: {
          isBack: true,
          title: 'Настройки по разделам работ',
        },
      },
      {
        path: 'works/list/:type?',
        name: 'work-type',
        component: WorkTypeView,
        meta: {
          isBack: true,
          title: 'Типы работ',
          replacedType: true,
        },
      },
      {
        path: 'works/create/:type?',
        name: 'work-type-create',
        component: WorkTypeCreate,
        meta: {
          isBack: true,
        },
      },
      {
        path: 'works/edit/:id/:type?',
        name: 'work-type-edit',
        component: WorkTypeEdit,
        meta: {
          isBack: true,
        },
      },
      {
        path: 'reports/:type',
        name: 'reports-type-list',
        component: ReportsViewType,
      },
      {
        path: 'analytics/plan',
        name: 'analytics-plan-list',
        component: AnalyticsView,
      },
      {
        path: 'analytics/job',
        name: 'analytics-job-list',
        component: AnalyticsJob,
      },
      {
        path: 'analytics/job-price',
        name: 'analytics-job-price-list',
        component: AnalyticsJobPrice,
      },
      {
        path: 'analytics/construction-engineering',
        name: 'construction-engineering',
        component: ConstructionEngineering
      },
      {
        path: 'analytics/performance',
        name: 'performance',
        component: Performance
      },
      {
        path: 'analytics/welding',
        name: 'welding',
        component: Welding
      },
      {
        path: 'analytics/amount',
        name: 'analytics-type-list',
        component: AnalyticsViewType,
      },
      {
        path: 'reports/create/:type',
        name: 'reportsCreate',
        component: ReportsCreate,
      },
      {
        path: 'reports/create/:id/:type',
        name: 'reportsCreate.id',
        component: ReportsCreate,
      },
      {
        path: 'reports/create/:id/:type/copy',
        name: 'reportsCopy',
        component: ReportsCreate,
      },
      {
        path: 'users/create',
        name: 'usersCreate',
        component: UsersCreate,
      },
      {
        path: 'users/create/:company',
        name: 'usersCreateCompany',
        component: UsersCreate,
      },
      {
        path: 'users/project',
        name: 'usersProject',
        component: ProjectsList,
      },
      {
        path: 'users/project/:id',
        name: 'selectUsers',
        component: SelectUsers,
      },
      {
        path: 'users/edit/:id',
        name: 'usersEdit',
        component: UsersEdit,
      },
      {
        path: 'settings',
        component: ProjectEdit,
      },
      {
        path: 'projects',
        component: ProjectsList,
      },
      {
        path: 'profile',
        component: ProfileEdit,
      },
      {
        path: 'jobs/:id?',
        name: 'JOB',
        component: JobsList,
        meta: {
          isBack: true,
          title: 'Работы',
        },
      },

      {
        path: 'jobs/:id/edit/:type?',
        name: 'JobEdit',
        component: JobsCreate,
        meta: {
          isBack: true,
        },
      },

      {
        path: 'jobs/:id/create/:type?',
        name: 'jobCreate',
        component: JobsCreate,
        meta: {
          isBack: true,
        },
      },

      {
        path: 'materials/create',
        name: 'materialsCreate',
        component: MaterialsCreate,
        meta: {
          isBack: true,
        },
      },

      {
        path: 'materials/:id/edit',
        name: 'MaterialsEdit',
        component: MaterialsCreate,
        meta: {
          isBack: true,
        },
      },

      {
        path: 'tech',
        name: 'TECH',
        component: JobsList,
        meta: {
          isBack: true,
          title: 'Техника',
        },
      },


      {
        path: 'prof',
        name: 'PROF',
        component: JobsList,
        meta: {
          isBack: true,
          title: 'Профессии',
        },
      },

      {
        path: 'materials',
        name: 'MATERIALS',
        component: JobsList,
        meta: {
          isBack: true,
          title: 'Материалы',
        },
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/index.js